export const getters = {
  group: state => state.group,
  groups: state => state.groups
}

export default getters



// WEBPACK FOOTER //
// ./src/store/module/group/getters.js